export const missingImageUrl = '/assets/images/no-photo-available.png';
